import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-548f926e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "formsContainer" }
const _hoisted_2 = { class: "formsContainer__header" }
const _hoisted_3 = { class: "formsContainer__body" }
const _hoisted_4 = { class: "categoryForm" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Gestión de Categorias", -1))
const _hoisted_6 = { class: "formContainer" }
const _hoisted_7 = { class: "formContainer__element" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "companyName" }, "Categorias", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Elige una categoria a eliminar", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "formContainer__element" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "formContainer__element__button--cancel" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Eliminar categoría"),
    /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "delete")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderApp = _resolveComponent("HeaderApp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HeaderApp, { "header-type": 'management' })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendDeleteRequest && _ctx.sendDeleteRequest(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("select", {
                id: "category",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.categoryId) = $event)),
                placeholder: "Elige una categoria"
              }, [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: category.category_id,
                    key: category.category_id
                  }, _toDisplayString(category.name), 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.categoryId]
              ])
            ]),
            _hoisted_11
          ], 32)
        ])
      ])
    ])
  ]))
}